import React, { useState } from 'react';
import './Tooltip.scss';

const Tooltip = ({ 
  children, 
  content, 
  position = 'bottom',
  delay = 0,
  maxWidth = '600px'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const showTooltip = () => {
    const id = setTimeout(() => {
      setIsVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setIsVisible(false);
  };

  return (
    <div 
      className="tooltip-wrapper"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
      {isVisible && (
        <div 
          className={`tooltip tooltip--${position}`}
          style={{ maxWidth }}
        >
          <div className="tooltip__content">
            {content}
          </div>
          <div className="tooltip__arrow"></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;